//# sourceMappingURL=translate.mjs.map
/// <reference types="./translate.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bit_array from "../../gleam_stdlib/gleam/bit_array.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $json_ from "../../tiamat/gleam/json_.mjs";
import * as $uuid from "../../youid/youid/uuid.mjs";
import * as $failable from "../data/failable.mjs";
import * as $language from "../data/translate/language.mjs";
import * as $iso639 from "../data/translate/language/iso639.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, Error, toList, CustomType as $CustomType, makeError, isEqual } from "../gleam.mjs";

const FILEPATH = "src/data/translate.gleam";

export class Translate extends $CustomType {
  constructor(content, id, kind, org_id, target_language, source_language) {
    super();
    this.content = content;
    this.id = id;
    this.kind = kind;
    this.org_id = org_id;
    this.target_language = target_language;
    this.source_language = source_language;
  }
}
export const Translate$Translate = (content, id, kind, org_id, target_language, source_language) =>
  new Translate(content, id, kind, org_id, target_language, source_language);
export const Translate$isTranslate = (value) => value instanceof Translate;
export const Translate$Translate$content = (value) => value.content;
export const Translate$Translate$0 = (value) => value.content;
export const Translate$Translate$id = (value) => value.id;
export const Translate$Translate$1 = (value) => value.id;
export const Translate$Translate$kind = (value) => value.kind;
export const Translate$Translate$2 = (value) => value.kind;
export const Translate$Translate$org_id = (value) => value.org_id;
export const Translate$Translate$3 = (value) => value.org_id;
export const Translate$Translate$target_language = (value) =>
  value.target_language;
export const Translate$Translate$4 = (value) => value.target_language;
export const Translate$Translate$source_language = (value) =>
  value.source_language;
export const Translate$Translate$5 = (value) => value.source_language;

export class DataPoint extends $CustomType {}
export const TranslateKind$DataPoint = () => new DataPoint();
export const TranslateKind$isDataPoint = (value) => value instanceof DataPoint;

export class Question extends $CustomType {}
export const TranslateKind$Question = () => new Question();
export const TranslateKind$isQuestion = (value) => value instanceof Question;

export class Answer extends $CustomType {}
export const TranslateKind$Answer = () => new Answer();
export const TranslateKind$isAnswer = (value) => value instanceof Answer;

export class Explanation extends $CustomType {}
export const TranslateKind$Explanation = () => new Explanation();
export const TranslateKind$isExplanation = (value) =>
  value instanceof Explanation;

/**
 * Short for MultipleChoice
 */
export class Choice extends $CustomType {}
export const TranslateKind$Choice = () => new Choice();
export const TranslateKind$isChoice = (value) => value instanceof Choice;

/**
 * A worksheet section header (H1-H3)
 */
export class Section extends $CustomType {}
export const TranslateKind$Section = () => new Section();
export const TranslateKind$isSection = (value) => value instanceof Section;

export class None extends $CustomType {}
export const TranslateKind$None = () => new None();
export const TranslateKind$isNone = (value) => value instanceof None;

export class Yes extends $CustomType {}
export const YesNoAnswer$Yes = () => new Yes();
export const YesNoAnswer$isYes = (value) => value instanceof Yes;

export class No extends $CustomType {}
export const YesNoAnswer$No = () => new No();
export const YesNoAnswer$isNo = (value) => value instanceof No;

export class NA extends $CustomType {}
export const YesNoAnswer$NA = () => new NA();
export const YesNoAnswer$isNA = (value) => value instanceof NA;

export class TranslationMetadata extends $CustomType {
  constructor(target_type, source) {
    super();
    this.target_type = target_type;
    this.source = source;
  }
}
export const TranslationMetadata$TranslationMetadata = (target_type, source) =>
  new TranslationMetadata(target_type, source);
export const TranslationMetadata$isTranslationMetadata = (value) =>
  value instanceof TranslationMetadata;
export const TranslationMetadata$TranslationMetadata$target_type = (value) =>
  value.target_type;
export const TranslationMetadata$TranslationMetadata$0 = (value) =>
  value.target_type;
export const TranslationMetadata$TranslationMetadata$source = (value) =>
  value.source;
export const TranslationMetadata$TranslationMetadata$1 = (value) =>
  value.source;

export class Translation extends $CustomType {
  constructor(id, target_id, content, language, version, metadata, created_at, failable) {
    super();
    this.id = id;
    this.target_id = target_id;
    this.content = content;
    this.language = language;
    this.version = version;
    this.metadata = metadata;
    this.created_at = created_at;
    this.failable = failable;
  }
}
export const Translation$Translation = (id, target_id, content, language, version, metadata, created_at, failable) =>
  new Translation(id,
  target_id,
  content,
  language,
  version,
  metadata,
  created_at,
  failable);
export const Translation$isTranslation = (value) =>
  value instanceof Translation;
export const Translation$Translation$id = (value) => value.id;
export const Translation$Translation$0 = (value) => value.id;
export const Translation$Translation$target_id = (value) => value.target_id;
export const Translation$Translation$1 = (value) => value.target_id;
export const Translation$Translation$content = (value) => value.content;
export const Translation$Translation$2 = (value) => value.content;
export const Translation$Translation$language = (value) => value.language;
export const Translation$Translation$3 = (value) => value.language;
export const Translation$Translation$version = (value) => value.version;
export const Translation$Translation$4 = (value) => value.version;
export const Translation$Translation$metadata = (value) => value.metadata;
export const Translation$Translation$5 = (value) => value.metadata;
export const Translation$Translation$created_at = (value) => value.created_at;
export const Translation$Translation$6 = (value) => value.created_at;
export const Translation$Translation$failable = (value) => value.failable;
export const Translation$Translation$7 = (value) => value.failable;

export class Translated extends $CustomType {
  constructor(org_id, id, content, target_language, kind, version, source, source_hash, failable) {
    super();
    this.org_id = org_id;
    this.id = id;
    this.content = content;
    this.target_language = target_language;
    this.kind = kind;
    this.version = version;
    this.source = source;
    this.source_hash = source_hash;
    this.failable = failable;
  }
}
export const Translated$Translated = (org_id, id, content, target_language, kind, version, source, source_hash, failable) =>
  new Translated(org_id,
  id,
  content,
  target_language,
  kind,
  version,
  source,
  source_hash,
  failable);
export const Translated$isTranslated = (value) => value instanceof Translated;
export const Translated$Translated$org_id = (value) => value.org_id;
export const Translated$Translated$0 = (value) => value.org_id;
export const Translated$Translated$id = (value) => value.id;
export const Translated$Translated$1 = (value) => value.id;
export const Translated$Translated$content = (value) => value.content;
export const Translated$Translated$2 = (value) => value.content;
export const Translated$Translated$target_language = (value) =>
  value.target_language;
export const Translated$Translated$3 = (value) => value.target_language;
export const Translated$Translated$kind = (value) => value.kind;
export const Translated$Translated$4 = (value) => value.kind;
export const Translated$Translated$version = (value) => value.version;
export const Translated$Translated$5 = (value) => value.version;
export const Translated$Translated$source = (value) => value.source;
export const Translated$Translated$6 = (value) => value.source;
export const Translated$Translated$source_hash = (value) => value.source_hash;
export const Translated$Translated$7 = (value) => value.source_hash;
export const Translated$Translated$failable = (value) => value.failable;
export const Translated$Translated$8 = (value) => value.failable;

/**
 * Do not change this value. The key of each stored choice translation comes
 * from this value.
 * 
 * @ignore
 */
const choice_namespace = "67327f9e-4a74-4c1e-bce7-6456e11a42fd";

/**
 * Do not change this value. The key of each stored section translation comes
 * from this value.
 * 
 * @ignore
 */
const section_namespace = "b7e703b9-8a56-465d-b2b5-74deea223bc1";

export function yes_no_answer(answer, l) {
  if (answer instanceof Yes) {
    return $language.to_yes(l);
  } else if (answer instanceof No) {
    return $language.to_no(l);
  } else {
    return $language.to_na(l);
  }
}

export function parse_yes_no(yes_no) {
  let $ = $string.lowercase(yes_no);
  if ($ === "yes") {
    return new Ok(new Yes());
  } else if ($ === "no") {
    return new Ok(new No());
  } else if ($ === "na") {
    return new Ok(new NA());
  } else {
    return new Error(undefined);
  }
}

export function yes_no_to_string(yes_no) {
  if (yes_no instanceof Yes) {
    return "YES";
  } else if (yes_no instanceof No) {
    return "NO";
  } else {
    return "NA";
  }
}

function display_non_default_language(language) {
  let emoji = $language.to_emoji(language);
  let language$1 = $string.capitalise($language.to_string(language));
  return $string.join(toList([emoji, language$1]), " ");
}

function display_default_language(language) {
  let emoji = $language.to_emoji(language);
  let language$1 = $string.capitalise($language.to_string(language));
  return $string.join(toList([emoji, language$1, "(default)"]), " ");
}

export function display_language(language, default_language) {
  let _block;
  if (default_language instanceof $option.Some) {
    let default_language$1 = default_language[0];
    _block = isEqual(default_language$1, language);
  } else {
    _block = false;
  }
  let is_default_language = _block;
  if (is_default_language) {
    return display_default_language(language);
  } else {
    return display_non_default_language(language);
  }
}

export function translation_target_to_small_string(target) {
  if (target instanceof DataPoint) {
    return "dp";
  } else if (target instanceof Question) {
    return "pq";
  } else if (target instanceof Answer) {
    return "pa";
  } else if (target instanceof Explanation) {
    return "ex";
  } else if (target instanceof Choice) {
    return "ch";
  } else if (target instanceof Section) {
    return "se";
  } else {
    return "no";
  }
}

export function translation_target_decoder() {
  return $decode.then$(
    $decode.string,
    (language) => {
      if (language === "question") {
        return $decode.success(new Question());
      } else if (language === "answer") {
        return $decode.success(new Answer());
      } else if (language === "data_point") {
        return $decode.success(new DataPoint());
      } else if (language === "explanation") {
        return $decode.success(new Explanation());
      } else if (language === "choice") {
        return $decode.success(new Choice());
      } else if (language === "section") {
        return $decode.success(new Section());
      } else if (language === "none") {
        return $decode.success(new None());
      } else {
        return $decode.failure(new Question(), "TranslationTarget");
      }
    },
  );
}

export function translation_target_to_string(target) {
  if (target instanceof DataPoint) {
    return "data_point";
  } else if (target instanceof Question) {
    return "question";
  } else if (target instanceof Answer) {
    return "answer";
  } else if (target instanceof Explanation) {
    return "explanation";
  } else if (target instanceof Choice) {
    return "choice";
  } else if (target instanceof Section) {
    return "section";
  } else {
    return "none";
  }
}

export function encode_translation_target(target) {
  if (target === "answer") {
    return new Answer();
  } else if (target === "question") {
    return new Question();
  } else if (target === "data_point") {
    return new DataPoint();
  } else if (target === "explanation") {
    return new Explanation();
  } else if (target === "choice") {
    return new Choice();
  } else if (target === "section") {
    return new Section();
  } else {
    return new None();
  }
}

export function translation_metadata_decoder() {
  return $decode.field(
    "target_type",
    translation_target_decoder(),
    (target_type) => {
      return $decrypt.optional_field(
        "source",
        $decode.string,
        (source) => {
          return $decode.success(new TranslationMetadata(target_type, source));
        },
      );
    },
  );
}

export function translation_decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "content",
        $decode.string,
        (content) => {
          return $decode.field(
            "target_id",
            $decrypt.uuid(),
            (target_id) => {
              return $decode.field(
                "language",
                $iso639.decoder(),
                (language) => {
                  return $decode.field(
                    "version",
                    $decode.int,
                    (version) => {
                      let metadata = $decrypt.json(
                        translation_metadata_decoder(),
                      );
                      return $decode.field(
                        "metadata",
                        metadata,
                        (metadata) => {
                          return $decrypt.optional_field(
                            "created_at",
                            $decrypt.timestamp(),
                            (created_at_opt) => {
                              let created_at = $option.unwrap(
                                created_at_opt,
                                $timestamp.system_time(),
                              );
                              let failable_decoder = $decrypt.json(
                                $failable.decoder($decode.string),
                              );
                              return $decrypt.optional_field(
                                "failable",
                                failable_decoder,
                                (failable) => {
                                  return $decode.success(
                                    new Translation(
                                      id,
                                      target_id,
                                      content,
                                      language,
                                      version,
                                      metadata,
                                      created_at,
                                      failable,
                                    ),
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function encode_translation_metadata(metadata) {
  let target_type = translation_target_to_string(metadata.target_type);
  return $json.object(
    toList([
      ["target_type", $json.string(target_type)],
      ["source", $json.nullable(metadata.source, $json.string)],
    ]),
  );
}

export function encode_translation(translation) {
  return $json.object(
    toList([
      ["content", $json.string(translation.content)],
      ["id", $json.string(translation.id)],
      ["version", $json.int(translation.version)],
      ["target_id", $json.string(translation.target_id)],
      ["language", $json.string($iso639.to_string(translation.language))],
      ["metadata", encode_translation_metadata(translation.metadata)],
      ["created_at", $json_.to_rfc3339(translation.created_at)],
      [
        "failable",
        $json.nullable(
          translation.failable,
          (_capture) => { return $failable.to_json(_capture, $json.string); },
        ),
      ],
    ]),
  );
}

/**
 * Whether a stored row holds a translation that can be shown. A failed or
 * pending row stores an empty `content`: a reader that takes `content` from it
 * would show an empty text instead of falling back to the source. A row
 * written before `failable` existed holds one.
 *
 * Not the rule of `languages_to_translate`: a pending row is a request in
 * flight, so it must not be asked again, though it holds no text yet.
 */
export function holds_translation(translation) {
  let $ = translation.failable;
  if ($ instanceof $option.Some) {
    let $1 = $[0];
    if ($1 instanceof $failable.Errored) {
      return false;
    } else if ($1 instanceof $failable.Pending) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}

function kind_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      if (kind === "data_point") {
        return $decode.success(new DataPoint());
      } else if (kind === "question") {
        return $decode.success(new Question());
      } else {
        return $decode.failure(new DataPoint(), "TranslateKind");
      }
    },
  );
}

export function decoder() {
  return $decode.field(
    "content",
    $decode.string,
    (content) => {
      return $decode.field(
        "id",
        $decode.string,
        (id) => {
          return $decode.field(
            "kind",
            kind_decoder(),
            (kind) => {
              return $decode.field(
                "org_id",
                $decode.string,
                (org_id) => {
                  return $decode.field(
                    "target_language",
                    $iso639.decoder(),
                    (target_language) => {
                      return $decrypt.optional_field(
                        "source_language",
                        $iso639.decoder(),
                        (source_language) => {
                          return $decode.success(
                            new Translate(
                              content,
                              id,
                              kind,
                              org_id,
                              target_language,
                              source_language,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function translate_to_json(data) {
  return $json.object(
    toList([
      ["content", $json.string(data.content)],
      ["id", $json.string(data.id)],
      ["kind", $json.string(translation_target_to_small_string(data.kind))],
      ["org_id", $json.string(data.org_id)],
      ["target_language", $json.string($iso639.to_string(data.target_language))],
      ["source_language", $json.nullable(data.source_language, $iso639.encode)],
    ]),
  );
}

/**
 * Builds the lookup key for a translation: `{lang}_{kind}_{target_id}`.
 * Used by the frontend store to index translations.
 */
export function translation_key(language, kind, target_id) {
  let _pipe = toList([
    $iso639.to_string(language),
    translation_target_to_small_string(kind),
    target_id,
  ]);
  return $string.join(_pipe, "_");
}

/**
 * Which of `languages` still need to be asked for, given the translations
 * that already exist for this target. Kind-aware: `existing` typically
 * holds every kind sharing that target (e.g. a `pq` row alongside a `pa`
 * row for the same element), so it is filtered down to `kind` first —
 * otherwise a French `pq` row would make a French `pa` ask look satisfied.
 *
 * With a known `language_source`, a change in the source-language content
 * (vs. the existing source-language translation, if any) requests every
 * language again rather than only the missing ones. Without a source
 * language (data points), content never changes once ingested, so only the
 * missing languages are requested.
 */
export function languages_to_translate(
  existing,
  kind,
  language_source,
  content,
  languages
) {
  let _block;
  let _pipe = existing;
  _block = $list.filter(
    _pipe,
    (t) => {
      return (isEqual(t.metadata.target_type, kind)) && !(() => {
        let $ = t.failable;
        if ($ instanceof $option.Some) {
          let $1 = $[0];
          if ($1 instanceof $failable.Errored) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      })();
    },
  );
  let existing$1 = _block;
  let _block$1;
  let _pipe$1 = languages;
  _block$1 = $list.filter(
    _pipe$1,
    (l) => {
      let _pipe$2 = existing$1;
      let _pipe$3 = $list.find(
        _pipe$2,
        (t) => { return isEqual(t.language, l); },
      );
      return $result.is_error(_pipe$3);
    },
  );
  let missing_languages = _block$1;
  if (language_source instanceof $option.Some) {
    let _block$2;
    let _pipe$2 = existing$1;
    _block$2 = $list.find(
      _pipe$2,
      (t) => { return isEqual(new $option.Some(t.language), language_source); },
    );
    let current_translation = _block$2;
    if (current_translation instanceof Ok) {
      let translated_content = current_translation[0].content;
      if (translated_content === content) {
        return missing_languages;
      } else {
        return languages;
      }
    } else {
      return languages;
    }
  } else {
    return missing_languages;
  }
}

export function choice_lookup_key(label, language) {
  return translation_key(language, new Choice(), label);
}

/**
 * Use only on Erlang. The hash function crashes in the browser. The function
 * does not trim the label or change its case, so labels that the author
 * wrote differently stay different.
 */
export function choice_target_id(label) {
  let $ = $uuid.from_string(choice_namespace);
  let namespace;
  if ($ instanceof Ok) {
    namespace = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/translate",
      391,
      "choice_target_id",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 11649,
        end: 11710,
        pattern_start: 11660,
        pattern_end: 11673
      }
    )
  }
  let $1 = $uuid.v5(namespace, $bit_array.from_string(label));
  let id;
  if ($1 instanceof Ok) {
    id = $1[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/translate",
      392,
      "choice_target_id",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $1,
        start: 11713,
        end: 11781,
        pattern_start: 11724,
        pattern_end: 11730
      }
    )
  }
  let _pipe = id;
  let _pipe$1 = $uuid.to_string(_pipe);
  return $string.lowercase(_pipe$1);
}

export function section_lookup_key(label, language) {
  return translation_key(language, new Section(), label);
}

/**
 * Use only on Erlang. The hash function crashes in the browser.
 */
export function section_target_id(label) {
  let $ = $uuid.from_string(section_namespace);
  let namespace;
  if ($ instanceof Ok) {
    namespace = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/translate",
      406,
      "section_target_id",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 12252,
        end: 12314,
        pattern_start: 12263,
        pattern_end: 12276
      }
    )
  }
  let $1 = $uuid.v5(namespace, $bit_array.from_string(label));
  let id;
  if ($1 instanceof Ok) {
    id = $1[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/translate",
      407,
      "section_target_id",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $1,
        start: 12317,
        end: 12385,
        pattern_start: 12328,
        pattern_end: 12334
      }
    )
  }
  let _pipe = id;
  let _pipe$1 = $uuid.to_string(_pipe);
  return $string.lowercase(_pipe$1);
}

/**
 * Returns the key to store a translation under in a lookup dict, for example
 * the frontend store or the export.
 *
 * The key must be a key that the reader can build at lookup time. For most
 * kinds, the reader knows the id of the question or answer, so the key uses
 * `target_id`: `"fr_pq_<question id>"`. For `Choice` and `Section`, the
 * reader knows only the text, because the browser cannot calculate the hash
 * in `target_id`. So the key uses the text in `metadata.source`:
 * `"fr_se_Security"`.
 *
 * Use this function each time you put translations in a lookup dict. To find
 * a translation, use `translation_key`, `choice_lookup_key` or
 * `section_lookup_key`.
 */
export function translation_index_key(translation) {
  let $ = translation.metadata.target_type;
  let $1 = translation.metadata.source;
  if ($1 instanceof $option.Some) {
    if ($ instanceof Choice) {
      let label = $1[0];
      return choice_lookup_key(label, translation.language);
    } else if ($ instanceof Section) {
      let label = $1[0];
      return section_lookup_key(label, translation.language);
    } else {
      return translation_key(
        translation.language,
        translation.metadata.target_type,
        translation.target_id,
      );
    }
  } else {
    return translation_key(
      translation.language,
      translation.metadata.target_type,
      translation.target_id,
    );
  }
}
